import request from '@/utils/request'


export function getOfficialAccountInfo() {
  return request({
    url: '/api/account/officialAccountInfo',
    method: 'get',
  })
}

// 获取账户信息
export function getOfficialList(pageNum,startTime){
  return request({
    url: '/api/bill/officialList',
    method: 'get',
    params: {
      startTime,
      pageNum
    }
  })
}
